import React, { useState, useEffect } from "react";
import "../../components/AddLeadSource/AddLeadSource.css";
import axios from "axios";

const AddLeadSource = ({tokenStorage,openAddProfile,setOpenAddProfile}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    LeadSourceID: "",
    LeadSource: "",
  
    createdBy: "Vishal",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddLeadSource`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
  
  
      // Optionally, reset the form
      setFormData({
        LeadSourceID: "",
        LeadSource: "",
      
        createdBy: "Vishal",
      });
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="leadSourceDetail">
        <div className="leadSource-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>LeadSource*</td>
             
            </tr>

            <tr>
              <td>
              <input
                  type="text"
                  name="LeadSource"
                  value={formData.LeadSource}
                  placeholder="Please Enter"
                  onChange={handleChange}
                />
              </td>
             
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addLeadSource-button">
          <button  type="submit"  onClick={handleSubmit} style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Add LeadSource
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddLeadSource;
